import { FC, HTMLAttributes, PropsWithChildren } from "react";
import { useCollapse } from "react-collapsed";

type ControlledCollapsableProps = HTMLAttributes<HTMLDivElement> & {
  isOpen: boolean;
};

const ControlledCollapsable: FC<
  PropsWithChildren<ControlledCollapsableProps>
> = ({ children, isOpen, ...props }) => {
  const { getCollapseProps } = useCollapse({ isExpanded: isOpen });

  return (
    <div {...props}>
      <div {...getCollapseProps()}>{children}</div>
    </div>
  );
};

export default ControlledCollapsable;
